export default Object.freeze([
    "postalCode",
    "postal_code",
    "employmentRole",
    "employment_role",
    "employmentSeniority",
    "employment_seniority",
    "displayLocation",
    "display_location",
    "latitude",
    "longitude",
    "displayName",
    "display_name",
    "githubHandle",
    "github_handle",
    "githubFollowers",
    "github_followers",
    "twitterHandle",
    "twitter_handle",
    "twitterFollowers",
    "twitter_followers",
    "facebookHandle",
    "facebook_handle",
    "linkedinHandle",
    "linkedin_handle",
    "bio",
    "gender",
    "site"
])




// WEBPACK FOOTER //
// ./src/scripts/constants/ClearbitBlacklist.js